import { Outlet, Link, useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useAuth from '../hooks/useAuth'
import LanguageSwitcher from './LanguageSwitcher'

export default function FacilitatorLayout() {
  const { t } = useTranslation()
  const { user, profile, signOut } = useAuth()
  const navigate = useNavigate()

  const handleSignOut = async () => {
    await signOut()
    navigate('/login', { replace: true })
  }

  return (
    <div className="min-h-screen">
      <header className="bg-white border-b border-gray-200 shadow-sm">
        <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/facilitator" className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-primary-500 to-primary-600 rounded-lg flex items-center justify-center text-white font-display font-semibold text-sm shadow">
              CSI
            </div>
            <h1 className="font-display text-xl font-medium text-gray-800">
              {t('nav.facilitatorDashboard')}
            </h1>
          </Link>

          <nav className="flex items-center gap-2">
            <Link
              to="/facilitator"
              className="px-3 py-1.5 text-sm font-semibold text-gray-600 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {t('nav.clientPairs')}
            </Link>
            <Link
              to="/facilitator/profile"
              className="relative px-3 py-1.5 text-sm font-semibold text-gray-600 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {t('nav.myProfile')}
              {profile?.pending_email && (
                <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-amber-400 rounded-full" />
              )}
            </Link>
            <Link
              to="/facilitator/manual"
              className="px-3 py-1.5 text-sm font-semibold text-gray-600 rounded-lg hover:bg-gray-100 transition-colors"
            >
              {t('nav.facilitatorGuide')}
            </Link>
            <Link
              to="/facilitator/create-pair"
              className="px-3 py-1.5 text-sm font-semibold text-white bg-primary-500 rounded-lg hover:bg-primary-600 transition-colors"
            >
              {t('nav.createPair')}
            </Link>
          </nav>

          <div className="flex items-center gap-4">
            <LanguageSwitcher />
            <span className="text-sm text-gray-500 hidden sm:inline">
              {user?.email}
            </span>
            <Link
              to="/facilitator/change-password"
              className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
            >
              {t('nav.changePassword')}
            </Link>
            <button
              onClick={handleSignOut}
              className="px-4 py-2 text-sm font-semibold text-gray-600 bg-gray-100 rounded-lg transition-all hover:bg-gray-200"
            >
              {t('nav.signOut')}
            </button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-5 py-6">
        <Outlet />
      </main>
    </div>
  )
}
